import MeetingNotificationReceiveSetting from './MeetingNotificationReceiveSetting'
import Http from '../../network/Http'
import {Nullable} from '../../app/TypeHelpers'
import {ApiResponse} from '../../network/response/ApiResponse'
import {ContentsForPagination} from '../shared/ContentsForPagination'

export class AdminNotificationReceiveSettingRepo {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    getEndpoint(): string {
        return '/api/admin/notification/meeting/receive-setting'
    }

    async searchMeetingNotificationReceiveList(
        condominiumGroupId: number,
        keyword: Nullable<string>,
        isOnlyEnabled: boolean,
        rowsPerPage: number,
        offset?: number,
    ): Promise<ContentsForPagination<MeetingNotificationReceiveSetting>> {
        const queryParameter: string[] = [`condominiumGroupId=${condominiumGroupId}`, `rowsPerPage=${rowsPerPage}`]
        if (keyword) {
            queryParameter.push(`keyword=${encodeURIComponent(keyword)}`)
        }
        if (isOnlyEnabled) {
            queryParameter.push('isOnlyEnabled=true')
        }
        if (offset) {
            queryParameter.push(`offset=${offset}`)
        }

        const uri: string = this.getEndpoint() + '/search?' + queryParameter.join('&')

        const response: ApiResponse<ContentsForPagination<MeetingNotificationReceiveSetting>> =
            await this.http.get(uri)
        const apiResponse = ApiResponse.fromContentsForPagination(response, MeetingNotificationReceiveSetting.from)

        return apiResponse.details
    }

    async getMeetingNotificationReceiveSetting(condominiumCd: string): Promise<MeetingNotificationReceiveSetting> {
        const response: ApiResponse<MeetingNotificationReceiveSetting> = await this.http.get(
            this.getEndpoint() + `/condominiums/${condominiumCd}`,
        )
        const apiResponse = ApiResponse.from(response, MeetingNotificationReceiveSetting.from)

        return apiResponse.details
    }

    async updateNotificationReceiveSetting(condominiumCd: string, isReceive: boolean): Promise<void> {
        await this.http.put(
            this.getEndpoint() + `/condominiums/${condominiumCd}`,
            {isReceive},
        )
    }
}
